import { useState, useEffect } from 'react';
import { Button, GridContainer, GridItem, Modal } from '../../components/shared';
import { Box, Grid, TextField } from '@mui/material';
import { MESSAGE } from '../../constants/message';
import useStyles from './style';

const EditAreaTaxLocationModal = ({ open, onClose, onConfirm, selectedLocation }) => {
  const styles = useStyles();
  const [locationName, setLocationName] = useState('');

  useEffect(() => {
    if (selectedLocation) {
      setLocationName(selectedLocation.areaTaxLocationName || '');
    }
  }, [selectedLocation]);

  const handleConfirm = () => {
    if (locationName.trim() !== '') {
      onConfirm({
        id: selectedLocation.id,
        areaTaxLocationName: locationName.trim(),
      });
    }
  };

  const handleClose = () => {
    setLocationName('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={'Edit Area Tax Location Name'}
      titleVariant="subtitle10"
      actionButtons={
        <Box my={3}>
          <Button variant="contained" size="large" onClick={handleConfirm} disabled={locationName.trim() === ''}>
            {MESSAGE.CONFIRM}
          </Button>
          <Button size="large" onClick={handleClose} variant={'text'}>
            {MESSAGE.CANCEL}
          </Button>
        </Box>
      }
      maxWidth={'xs'}
    >
      <Grid>
        <GridContainer rowSpacing={2} gap={2}>
          <GridItem>
            <TextField
              fullWidth
              label={'Area Tax Location Name'}
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
              placeholder="Enter location name"
            />
          </GridItem>
          <GridItem>
            <div className={styles.disclaimerStyle}>
              <em>This action will update the location name. Any associated records will reflect this new name.</em>
            </div>
          </GridItem>
        </GridContainer>
      </Grid>
    </Modal>
  );
};

export default EditAreaTaxLocationModal;
